import React, { useState } from "react"
import MeetingRatesEdit from './components/MeetingRatesEdit'
import MeetingRatesView from './components/MeetingRatesView'

const MeetingRates = (props: any) => {
    const [editFlag, setEditFlag] = useState(false)
    const ratesdata = { ...props.allAPIdata.meetingrooms.rates, ...{ meetingroomsid: props.allAPIdata.meetingrooms.meetingroomsid, meetingroomslangid: props.allAPIdata.meetingrooms.meetingroomslangid } }
    const [ratesData, setRatesData] = useState<any>(ratesdata)
    return (
        <div>
            {editFlag ? <MeetingRatesEdit ratesData={ratesData} setRatesData={setRatesData} setOneNavDisabled={props.setOneNavDisabled} setEditFlag={setEditFlag} /> :
                <MeetingRatesView ratesData={ratesData} setOneNavDisabled={props.setOneNavDisabled} setEditFlag={setEditFlag} />}
        </div>
    )
}

export default MeetingRates